import styled from 'styled-components';
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { useOutsideClick } from '@src/hooks/useOutsideClick';

const NumberFormatted = styled(NumberFormat)`
  ${({ width, height }) => `
    width: ${width ? `${width}px` : '100%'};
    height: ${height || '58'}px;
    font-size: 16px;
    padding: 10px 16px;
    font-family: UbuntuRegular;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #3f4957;
    border-radius: 4px;

    &.has-error {
      border-color: #dc3545;
      box-shadow: 0 0 8px 1px rgba(220, 53, 69, 0.08);
    }

    @media (max-width: 767.98px) {
      font-size: 14px;
    }

    ::placeholder {
      color: #6b7789;
    }

    :focus {
      border-color: #0d6efd;
      box-shadow: 0 0 8px 1px rgba(22, 32, 86, 0.08);
    }

    :hover {
      border-color: #0d6efd;
    }
  `}
`;

const CustomMoneyInput = ({ onChange, addUpdatePrice, record, value, disable = false, setDisable = () => {}, ...props }) => {
  const [val, setVal] = useState(value || '');
  const ref = useRef();

  const outsideClickHandler = () => {
    if (!ref.current || ref.current.value === '' || ref.current.value === '0,00') {
      setVal(0);
    }
  };

  useOutsideClick(ref, outsideClickHandler);

  useEffect(() => {
    if (record && val !== record.price) {
      setVal(record.price);
    }
  }, [record]);

  const handleValueChange = ({ floatValue }) => {
    onChange?.(floatValue);
    setVal(floatValue);
  };

  const handleBlur = async (e) => {
    if (record) {
      await addUpdatePrice(e.target.value, record);
    }
    if (val === undefined) {
      setVal(0);
    }
  };

  const handleFocus = () => {
    if (val === 0) {
      setVal('');
    }
  };

  return (
    <NumberFormatted
      tabIndex={0}
      allowNegative={false}
      precision={2}
      fixedDecimalScale
      className={`ant-input ${props.className || ''}`}
      value={val}
      decimalScale={2}
      thousandSeparator="."
      decimalSeparator=","
      onValueChange={handleValueChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      getInputRef={(r) => (ref.current = r)}
      disabled={disable}
      {...props}
    />
  );
};

CustomMoneyInput.propTypes = {
  onChange: PropTypes.func,
  addUpdatePrice: PropTypes.func,
  record: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disable: PropTypes.bool,
  setDisable: PropTypes.func,
};

CustomMoneyInput.defaultProps = {
  onChange: () => {},
  addUpdatePrice: () => {},
  record: null,
  value: '',
  disable: false,
  setDisable: () => {},
};

export default CustomMoneyInput;
